import { sendLog } from '@/api/pc/common'
import { goSaasLoginPage, isProd } from '@/utils/index' // eslint-disable-line

export default {
  data() {
    const { name, params } = this.$route

    return {
      moduleFlag: `${name}_${params.moduleIndex}`
    }
  },
  watch: {
    $route() {
      console.log('-----reload-----')
      this.$parent.reload()
    }
  },
  methods: {
    getModuleData() {
      const { name, params } = this.$route
      return this._moduleInfo[`${name}_${params.moduleIndex}`]
    }
  },
  async created() {
    const websiteId = this._websiteInfo.id
    const routerName = this.$route.name
    const currentModuleIndex = Number(this.$route.params.moduleIndex)

    let websiteModuleId = ''
    let isPublic = true

    if (routerName === 'index') {
      websiteModuleId = websiteId
    } else {
      for (let i = 0; i < this._modules.length; i++) {
        const item = this._modules[i]

        if (item.router === routerName && item.moduleIndex === currentModuleIndex) {
          websiteModuleId = item.id
          isPublic = item.publik
          break
        }
      }
    }
    
    if (isProd() && websiteModuleId) {
      try {
        await sendLog({
          websiteId,
          websiteModuleId
        })
      } catch (e) {
        if (!isPublic) {
          goSaasLoginPage()
        }
      }
    }
  }
}
